import { Component, Inject, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription, timer } from 'rxjs';

import { PermissionService } from 'src/app/core/services/authentication/permission.service';
import { AuthTokenService } from './../../../core/services/authentication/auth-token.service';
import { DialogConfig } from './../../../core/services/dialog.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { DialogStatus } from 'src/app/core/services/dialog.service';

@Component({
    selector: 'app-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss'],
    standalone: false
})
export class MessageDialogComponent implements OnInit, OnDestroy {

  config: DialogConfig = {};

  public statusTypes: typeof DialogStatus = DialogStatus;
  subscription: Subscription

  constructor(
    private permissionService: PermissionService,
    private cd: ChangeDetectorRef,
    private dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
    this.config = data;
  }


  ngOnInit() {

    AppDomService.hideScrollblock();

    //automatic close dialog by timer
    if (this.config?.duration) {
      const source = timer(1000, 1000);
      this.subscription = source.subscribe(
        (val) => {
          if (val == this.config.duration)
            this.close();
        }
      );
    }

  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  close() {
    this.dialogRef.close();
    this.subscription?.unsubscribe()
  }

  onRedirectToLogin() {
    this.permissionService.isShowErr401Dialog=false;
    //after signup , you must go to login
    this.ngOnDestroy();
    this.dialogRef.close();
  }


  onClickOkButton(){
    if(this.config.redirectToLogin)
      window.location.replace(window.location.origin);
  }

  ngOnDestroy(): void {

    if (this.config.status == DialogStatus.register || this.config.status == DialogStatus.login) {
      AuthTokenService.clearAllToken();
      window.location.replace(window.location.origin);
    }

    if(this.config.redirectToLogin)
    window.location.replace(window.location.origin);

    this.subscription?.unsubscribe()
  }

}
